import React, { useContext, useState, useRef } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import InvoiceTab from './tab';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

const StyledClick = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 4.164vw;
  width: 84.903vw;
  border-radius: 2.082vw;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
`;

const Wrapper = styled.div`
  position: relative;
  height: ${(props) =>
    props.open ? props.ordersMaxCount * 13.608 + 3.12 + 6.767 + 'vw' : '4.164vw'};
  width: 96vw;
  transition: 300ms linear;
  border-radius: 2.082vw;
  margin-top: 0.78vw;
  color: ${(props) => (props.open ? props.theme.textPrimary : props.theme.textSecondary)};
  padding-top: 4.424vw;
  padding-left: 1.561vw;
  padding-right: 1.561vw;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 0.937vw;
  background-color: ${(props) =>
    props.open || props.loading ? props.theme.cardBackground : 'unset'};
  overflow: hidden;
  &:hover {
    background-color: ${(props) => props.theme.cardBackground};
    color: ${(props) => props.theme.textPrimary};
  }
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
`;

export const Element = styled.div`
  position: absolute;
  top: ${(props) => (props.top ? props.top : '1.7vw')};
  left: ${(props) => (props.rtlDirection ? 'unset' : props.left)};
  right: ${(props) => (props.rtlDirection ? props.left : 'unset')};
  transition: 300ms linear;
`;

export const Invoices = styled.div`
  position: relative;
  height: calc(100vh - 9.2vw);
  padding-left: ${(props) => (props.rtlDirection ? '0vw' : '1.04vw')};
  padding-right: ${(props) => (props.rtlDirection ? '1.04vw' : '0vw')};
  margin-top: 0.26vw;
  width: calc(99vw);
  box-sizing: border-box;
  overflow: auto;
  /* width */
  ::-webkit-scrollbar {
    width: 1vw;
    border-radius: 1vw;
    background-color: ${(props) => props.theme.SecondaryBackground};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 0.26vw grey;  */
    border-radius: 1vw;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.borderBackground};
    border: 0vw solid #f4f4f4;
    border-radius: 1vw;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.tagBorder};
  }
`;

const Invoice = (props) => {

  const ref = useRef(null);

  const { theme } = useContext(ThemeContext);

  const [left, setLeft] = useState(0);
  const [lastLeft, setLastLeft] = useState(0);
  const [top, setTop] = useState(0);
  const [lastTop, setLastTop] = useState(0);
  const [dragStatus, setDragStatus] = useState(false);
  const [dragOrderStatus, setDragOrderStatus] = useState(0);
  const [dragingOrder, setDragingOrder] = useState({ status: 1 });

  // const [selectedInvoice, setSelectedInvoice] = useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(false);
  const [onMouseDownX, setOnMouseDownX] = useState(0);
  const [onMouseDownY, setOnMouseDownY] = useState(0);
  const { t } = useTranslation();

  const {
    orders,
    setOpenOrders,
    openOrders,
    invoiceId,
    setOrderLastStatus,
    notifications,
    hubId,
    onEditClickHandler,
    open
  } = props;

  let notificationsByOrder = {};
  if (notifications) {
    notifications.map((notification) => {
      if (!notificationsByOrder[notification.order_id]) {
        notificationsByOrder[notification.order_id] = [notification];
      } else {
        notificationsByOrder[notification.order_id].push(notification);
      }
    });
  }

  const onMouseDown = (event, orderStatus, order) => {
    setDragOrderStatus(orderStatus);
    setDragingOrder(order);
    setLastLeft(event.clientX);
    setLastTop(event.clientY);
    setOnMouseDownX(event.clientX);
    setOnMouseDownY(event.clientY);
    setDragStatus(true);
  };
  const onMouseMove = (event) => {
    if (dragStatus) {
      
      const windowInnerWidth = window.innerWidth;
      const helper = lastLeft;
      const helperY = lastTop;
      setLeft(left + (100 * (event.clientX - helper)) / windowInnerWidth);
      setLastLeft(event.clientX);
      setTop(top + (100 * (event.clientY - helperY)) / windowInnerWidth);
      setLastTop(event.clientY);
    }
  };
  const onMouseUp = (status) => {
    setDragStatus(false);
    setLastLeft(0);
    setLastTop(0);
    setLeft(0);
    setTop(0);
  };

  const statusLength = (i) => {
    const filtered = props.orderIds.filter((order) => {
      if (i !== 1) {
        return order.status === i;
      } else {
        return order.status === 1 || order.status === 7 || order.status === 8 || order.status === 9;
      }
    });
    // const filtered = props.orderIds.filter((order) => order.status === i);
    return filtered.length;
  };

  const filterOrders = (i) => {
    if (i !== 1) {
      return props.orders.filter((order) => order.status === i);
    } else {
      return props.orders.filter((order) => order.status === 1 || order.status === 7 || order.status === 8 || order.status === 9);
    }
    // const filtered = props.orders.filter((order) => order.status === i);
    // return filtered;
  };

  const heightHelper = (i) => {
    let newStatus = Math.floor((left * 10000 + 66282.5) / 132565) + dragOrderStatus;
    let helper = 0;
    if (dragStatus && newStatus !== i && dragOrderStatus === i && newStatus > 0 && newStatus < 7) {
      helper = -1;
    }
    if (dragStatus && newStatus === i && dragOrderStatus !== i) {
      helper = 1;
    }
    return helper;
  };
  let statusLengthArray = [
    statusLength(1) + heightHelper(1),
    statusLength(2) + heightHelper(2),
    statusLength(3) + heightHelper(3),
    statusLength(4) + heightHelper(4),
    statusLength(5) + heightHelper(5),
    statusLength(6) + heightHelper(6),
  ];
  let statusLengthArrayHelper = [
    statusLength(1),
    statusLength(2),
    statusLength(3),
    statusLength(4),
    statusLength(5),
    statusLength(6),
  ];

  const handleClick=(event)=>{
    
    if(!open){
      ref.current?.scrollIntoView({ behavior:'smooth' });    
    }
    else{
      //fix bug click on an open invoice after another invoice is opened 
      event.preventDefault();
    }
  }

  return (
    <>
    
    <Link id={props.invoiceId} onClick={handleClick} style={{ textDecoration: 'none' }} to={props.link} draggable='false'>

    <Wrapper
      ref={ref}
      theme={theme}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      open={props.open}
      loading={props.loading}
      ordersMaxCount={Math.max(...statusLengthArray, ...statusLengthArrayHelper)}
    >
      <StyledClick onClick={props.onClick} />
      {props.children}
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(1)}
        ordersCount={statusLengthArray[0]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Uncomplete')}
      </InvoiceTab>
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(2)}
        ordersCount={statusLengthArray[1]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Order registered')}
      </InvoiceTab>
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(3)}
        ordersCount={statusLengthArray[2]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Preparing for print')}
      </InvoiceTab>
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(4)}
        ordersCount={statusLengthArray[3]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Printing')}
      </InvoiceTab>
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(5)}
        ordersCount={statusLengthArray[4]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Packaging & Shipping')}
      </InvoiceTab>
      <InvoiceTab
        notificationsByOrder={notificationsByOrder}
        left={left}
        top={top}
        onMouseDown={onMouseDown}
        onOrderClick={props.onOrderClick}
        orders={filterOrders(6)}
        ordersCount={statusLengthArray[5]}
        open={props.open}
        link={props.link}
        isOrderModalOpen= {props.isOrderModalOpen}
      >
        {t('dashboard.table.status.Shipped')}
      </InvoiceTab>
    </Wrapper>
     </Link>
     </>
  );
};

export default Invoice;

